import { render, staticRenderFns } from "./ModalCadastroCalendario.vue?vue&type=template&id=6552075b"
import script from "./ModalCadastroCalendario.vue?vue&type=script&lang=js"
export * from "./ModalCadastroCalendario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports